import LoadingComponent from '@/components/loading'

const loadingPlugin = (Vue, options) => {
  const Loading = Vue.extend(LoadingComponent)
  let $vm

  if (!$vm) {
    $vm = new Loading({
      el: document.createElement('div')
    })
    document.body.appendChild($vm.$el)
  }

  const loadingFn = {
    initImgSrc(src) {
      if (typeof src === 'string' && !!src) {
        $vm.imgSrc = src
      }
    },
    show() {
      $vm.show = true
    },
    hide() {
      $vm.show = false
    },
    isVisible() {
      return $vm.show
    }
  }
  Vue.prototype.$logoLoading = loadingFn
}
export default loadingPlugin